import { Badge } from "@/components/ui/badge"
import { cn } from "@/lib/utils"

export type StatusTone =
  | "default"
  | "success"
  | "warning"
  | "danger"
  | "info"
  | "muted"

const tones: Record<StatusTone, string> = {
  default: "bg-muted text-foreground",
  success:
    "bg-emerald-100 text-emerald-700 dark:bg-emerald-500/15 dark:text-emerald-300",
  warning:
    "bg-amber-100 text-amber-700 dark:bg-amber-500/15 dark:text-amber-300",
  danger: "bg-red-100 text-red-700 dark:bg-red-500/15 dark:text-red-300",
  info: "bg-sky-100 text-sky-700 dark:bg-sky-500/15 dark:text-sky-300",
  muted: "bg-muted text-muted-foreground",
}

interface StatusBadgeProps {
  tone?: StatusTone
  children: React.ReactNode
  className?: string
}

export function StatusBadge({ tone = "default", children, className }: StatusBadgeProps) {
  return (
    <Badge variant="outline" className={cn("border-0", tones[tone], className)}>
      {children}
    </Badge>
  )
}
